// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_RSG","cls2":"CreateSocialItem-cls2_k9X CreateSocialItem-cls1_RSG"};